import { render, staticRenderFns } from "./Func14Listagem.vue?vue&type=template&id=b94a727e"
import script from "./Func14Listagem.vue?vue&type=script&lang=js"
export * from "./Func14Listagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports